<template lang="pug">
  #kr-container.max-w-lg(:class="{ lg: size == 'lg'}")
    .relative
      .relative
        button#parentSetter.bg-gray-1.shadow-none.w-auto.p-1.pl-2.mb-2.overflow-visible.text-gray-7(:class="{ lg: size == 'lg'}" class="sm:text-sm sm:flex-wrap sm:justify-start sm:text-left" @click="showParentDropdown = true")
          span.text-gray-5(class="sm:w-full") Under:
          span.inline-flex.items-center
            span.ml-1(class="sm:ml-0" v-if="parent") {{parent.title}}
            eva-icon.icon(name="chevron-down")
          
        .dropdown.absolute.left-0.top-0(v-if="showParentDropdown")
          .fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showParentDropdown = false")
          .relative.bg-white.p-4.shadow-xl.mt-10.rounded-lg.z-10
            div.items-start(v-for="objective in liveObjectives")
              .flex.items-center
                p.mr-2.text-gray-5 O:
                .rounded-lg.bg-gray-2.p-2.mb-1.flex-shrink-0.cursor-pointer.text-gray-7(class="hover:bg-gray-3" :class="{ activeSelection: objective.id == keyResult.parent}" @click="changeParent(objective.id)") {{objective.title}}
              
              .ml-6(v-for="kr in keyResults" v-if="kr.parent == objective.id")
                .flex.items-center
                  p.mr-2.text-gray-5 KR:
                  .rounded-lg.bg-gray-2.p-2.mb-1.cursor-pointer.text-gray-7(class="hover:bg-gray-3" :class="{ activeSelection: kr.id == keyResult.parent, disabled: kr.id == keyResult.id}"  @click="changeParent(kr.id)") {{ kr.title}}
    
    .content-card.card.w-full
      .flex(class="lg:flex-wrap")
        .relative(class="lg:m-0")
          DoughnutChart#kr-chart.mr-4(:width="chart.size" :height="chart.size" :strokeWidth="chart.stroke" backgroundColor="#f1f3f5" :foregroundColor="color" :percent="getPercent" )

          #kr-value.flex.items-center.justify-center.w-20.h-20.absolute.top-0
            p.font-semibold.text-xl.text-gray-9 {{getPercent}}%

        .flex-grow
          Resizable(v-if="size == 'lg'")
            textarea#kr-title.ghost.text-xl.font-medium.text-gray-9.mt-4(@input="changes = true" @blur="saveKeyResult" @keyup.enter="blur" v-model="keyResult.title" placeholder="Title")
          
          Resizable(v-else)
            textarea#kr-title.ghost.text-xl.font-medium.text-gray-9.mt-4(v-focus @input="changes = true" @blur="saveKeyResult" @keyup.enter="blur" v-model="keyResult.title" placeholder="Title")

          Resizable
            textarea.ghost.w-full.h-auto(@input="changes = true" @blur="saveKeyResult" @keyup.enter="blur" v-model="keyResult.description" placeholder="Description")

          h3.text-sm.font-medium.mt-4.mb-1 Status
          .flex.p-1.w-full.rounded.bg-gray-1.text-gray-6.uppercase.text-center.text-xs.tracking-wide.cursor-pointer.max-w-sm(@click="changes = true; saveKeyResult()")
            .rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{blue: keyResult.status == 'On track'}" @click="keyResult.status = 'On track'") On track
            .rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{orange: keyResult.status == 'At risk'}" @click="keyResult.status = 'At risk'") At risk
            .rounded.p-1.flex-grow(class="hover:bg-gray-3" :class="{red: keyResult.status == 'Off track'}" @click="keyResult.status = 'Off track'") Off track
          
          .border-t.mt-8.mb-4

          .flex(v-if="keyResult.id")
            .flex-grow.relative.max50
              h3.text-sm.font-medium.mt-4 Teams
                Teams(:selectedTeams="keyResult.teams" parentType="keyResult" :parentId="keyResult.id" @done="setup")
                      
            .flex-grow.relative.max50
              h3.text-sm.font-medium.mt-4 Owners
                Teammates(:owners="keyResult.owners" :parentId="keyResult.id" @done="setup")
              

          .flex.mt-8
            .flex-grow.max50.target
              h3.text-sm.font-medium.mt-4 Target
              .flex.items-baseline.relative
                p.text-gray-5.mr-1(v-if="unitIsCurrency") {{keyResult.unit}}
                input.ghost.text-gray-7.rounded-none.w-2(@input="changes = true" class="hover:border-b hover:border-2" placeholder="1" @click="select" @blur="saveKeyResult" @keyup.enter="blur" v-model="keyResult.initialValue" v-autowidth="{maxWidth: '120px', minWidth: 'none'}")
                p.mx-2.font-normal.text-gray-6 of 
                p.text-gray-5.mr-1(v-if="unitIsCurrency") {{keyResult.unit}}
                input.ghost.text-gray-7.rounded-none.w-2(@input="changes = true" class="hover:border-b hover:border-2" placeholder="1" @click="select" @blur="saveKeyResult" @keyup.enter="blur" v-model="keyResult.targetValue" v-autowidth="{maxWidth: '120px', minWidth: 'none'}")
                
                button.p-0.ml-1.pl-1.shadow-none.text-xs.text-gray-5.-mt-2.w-auto(@click="showUnitDropdown = true") 
                  span(v-if="!unitIsCurrency && keyResult.unit") {{keyResult.unit}}
                  span(v-else) Unit
                  eva-icon.icon.text-gray-4(name="chevron-down")

                .dropdown.absolute.left-0.top-0(v-if="showUnitDropdown")
                  .fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showUnitDropdown = false")
                  .relative.bg-white.p-4.shadow-xl.mt-20.rounded-lg.z-10
                    input(v-focus v-model="keyResult.unit" placeholder="$, USD, cm, or things" @click="select" @blur="changeUnit" @keyup.enter="blur")
                      
            .flex-grow.relative.max50.cycle
              h3.text-sm.font-medium.mt-4 Cycle
              button.p-1.w-auto.-ml-1.shadow-none.mt-2.font-normal(@click="showQuarterDropdown = true")
                eva-icon.icon.text-gray-5(name="calendar")
                span.ml-2.text-gray-7 {{keyResult.cycle}}
                eva-icon.icon.text-gray-4(name="chevron-down")
              
              .dropdown.absolute.left-0.top-0(v-if="showQuarterDropdown")
                .fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showQuarterDropdown = false")
                .relative.bg-white.p-4.shadow-xl.mt-20.rounded-lg.z-10
                  div.items-start(v-for="quarter in quarters")
                    .rounded-lg.bg-gray-2.p-2.mb-1.flex-shrink-0.cursor-pointer(class="hover:bg-gray-3" :class="{ activeSelection: quarter == keyResult.cycle[1]}" @click="changeQuarter(quarter)") Q{{quarter}} {{currentYear()}}

          .krs(v-if="!isNested && keyResult.id && size == 'lg'")
            h3.text-sm.font-medium.mt-4.border-t.pt-8 Nested Key Results
            KeyResultListItem(v-for="keyResult in nestedKeyResults" :key="keyResult.id" :keyResult="keyResult")

            .createKr.card.outlined.flex.items-center.active.mt-2(@click="showKrModal = true")
              .rounded-full.w-8.h-8.mr-4.bg-gray-5.flex.justify-center.items-center.flex-shrink-0
                eva-icon.icon.text-white(name="plus")

              div
                h3.text-gray-7 Create a Key Result
                p.text-sm.text-gray-6.font-normal What do you need to achieve for this key result?
            
            Modal(v-if="showKrModal" @close="showKrModal = false")
              CreateKeyResult(:parentId="keyResult.id" @close="showKrModal = false")
          
          button.small.shadow-none.mt-16.-ml-2(v-if="keyResult.id" @click="deleteKeyResult")
            eva-icon.icon.text-gray-5(name="trash-2" width="16" height="16")
            span.ml-1 Delete this goal
          p.text-xs.mt-2.text-gray-6(v-if="nestedKeyResults.length") If you delete this goal, nested goals will be gone forever

        #updatesCard.bg-gray-0.p-4.rounded-lg.w-full.max-w-xs.ml-4.flex.flex-col.content-start.items-start(v-if="size == 'lg'" class="lg:ml-40 lg:max-w-4xl lg:mt-8")
          h3.text-sm.font-medium Updates

          router-link.button.icon.main.small.overflow-hidden.pr-1.my-2(:to="`/update?kr=${keyResult.id}`")
            eva-icon.icon.text-indigo-3.bg-indigo-8.rounded-tr-lg.rounded-br-lg.p-1(name="plus") 
            span.mx-2 New update

          UpdateCard(v-for="update in krUpdates" :key="update.id" :krUpdates="krUpdates" :update="update" @done="setup")
    
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Resizable from "./Resizable";
import KeyResultListItem from "./KeyResultListItem";
import DoughnutChart from "vue-doughnut-chart";
import Teams from "./Teams";
import Modal from "../templates/Modal";
import Teammates from "./Teammates";
import UpdateCard from "./UpdateCard";
import CreateKeyResult from "./CreateKeyResult";

export default {
  props: ["keyResultId", "index", "size", "isNested", "parentId"],
  components: {
    Resizable,
    DoughnutChart,
    KeyResultListItem,
    Teams,
    Teammates,
    UpdateCard,
    CreateKeyResult,
    Modal
  },
  data() {
    return {
      showKrModal: false,
      showParentDropdown: false,
      showQuarterDropdown: false,
      showUnitDropdown: false,
      modalInner: "KeyResult",
      chart: {
        size: 80,
        stroke: 16
      },
      keyResult: {
        targetValue: 100,
        initialValue: 0,
        teams: [],
        owners: [],
        title: "",
        description: "",
        status: "On track",
        cycle: "",
        nestedKeyResults: [],
        parent: "",
        unit: "",
        companyId: "",
        id: ""
      },
      changes: false,
      quarters: ["1", "2", "3", "4"],
      units: ["Currency", "Custom unit"],
      tempKeyResult: null,
      tempNestedKeyResults: []
    };
  },
  created() {
    this.setup();
  },
  computed: {
    ...mapGetters([
      "company",
      "profile",
      "keyResults",
      "objectives",
      "updates"
    ]),
    liveObjectives() {
      return this.objectives.filter(obj => !obj.archived);
    },
    krUpdates() {
      return this.updates.filter(update => update.kr == this.keyResultId);
    },
    unitIsCurrency() {
      if (this.keyResult.unit && this.keyResult.unit.length <= 1) return true;
      else return false;
    },
    nestedKeyResults() {
      return this.keyResults.filter(kr => kr.parent == this.keyResultId);
    },
    color() {
      switch (this.keyResult.status) {
        case "On track":
          return "#228be6";
        case "At risk":
          return "#fd7e14";
        case "Off track":
          return "#fa5252";
        default:
          return "#fff";
      }
    },
    getPercent() {
      if (this.keyResult.initialValue == 0) return 0;
      else
        return Math.round(
          (this.keyResult.initialValue / this.keyResult.targetValue) * 100
        );
    },
    parent() {
      const obj = this.objectives.find(obj => obj.id == this.keyResult.parent);
      const keyr = this.keyResults.find(kr => kr.id == this.keyResult.parent);

      if (obj) return obj;
      else return keyr;
    }
  },
  methods: {
    ...mapActions(["blur", "select"]),
    setup() {
      if (this.keyResultId) {
        this.keyResult = this.keyResults.find(kr => kr.id == this.keyResultId);
      } else if (this.keyResult.id) {
        this.keyResult = this.keyResults.find(kr => kr.id == this.keyResult.id);
      } else {
        this.keyResult.parent = this.parentId;
        this.keyResult.companyId = this.profile.companyId;
        this.keyResult.cycle = `Q${this.currentQuarter()} ${this.currentYear()}`;
      }
      if (this.size == "lg") {
        this.chart.stroke = 24;
        this.chart.size = 128;
      }
    },
    saveKeyResult() {
      if (!this.keyResult.title || !this.changes) return;

      this.changes = false;

      const payload = {
        collection: "keyResults",
        id: this.keyResult.id,
        item: this.keyResult
      };

      if (payload.id.length)
        return this.$store.dispatch("updateDoc", payload).then(() => {
          this.$store.dispatch("getKeyResults", this.profile.companyId);
          this.notify();
        });
      else {
        heap.track("createKr");
        return this.$store.dispatch("createDoc", payload).then(doc => {
          this.keyResult.id = doc.id;
          this.$store.dispatch("getKeyResults", this.profile.companyId);
          this.notify();
        });
      }
    },
    changeParent(id) {
      if (this.keyResult.id == id) return;
      this.keyResult.parent = id;
      this.changes = true;
      this.showParentDropdown = false;
      this.saveKeyResult();
      this.$emit("rejig");
    },
    changeQuarter(quarter) {
      if (this.keyResult.cycle[1] == quarter) {
        this.showQuarterDropdown = false;
        return;
      }
      this.keyResult.cycle = `Q${quarter} ${this.currentYear()}`;
      this.changes = true;

      this.showQuarterDropdown = false;
      this.saveKeyResult();
    },
    changeUnit() {
      this.changes = true;
      this.showUnitDropdown = false;
      this.saveKeyResult();
    },
    notify() {
      this.$store.dispatch("fireNotification", {
        title: "Saved Key Result",
        type: "success"
      });
    },
    currentQuarter() {
      const today = new Date();
      return Math.floor((today.getMonth() + 3) / 3);
    },
    currentYear() {
      const today = new Date();
      return today.getFullYear();
    },
    deleteKeyResult() {
      this.tempKeyResult = this.keyResult;

      this.$router.push("/");

      this.$store
        .dispatch("deleteDoc", {
          collection: "keyResults",
          id: this.keyResult.id
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Deleted goal",
            message: "Made a mistake? You can undo.",
            timeOut: 7000,
            actions: [
              {
                text: "Undo",
                do: "createDoc",
                payload: {
                  collection: "keyResults",
                  id: this.tempKeyResult.id,
                  item: this.tempKeyResult
                },
                then: "getKeyResults",
                thenPayload: this.profile.companyId
              }
            ]
          });
          return this.$store.dispatch("getKeyResults", this.profile.companyId);
        });
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  },
  watch: {
    keyResultId() {
      this.setup();
    }
  }
};
</script>

<style lang="sass" scoped>
textarea
  resize: none

#kr-container.lg
  max-width: none
  @apply w-auto -ml-40 pr-2

  #kr-value
    @apply w-32 h-32

  .content-card
    @apply shadow-none p-0 mt-8 pr-2 -mr-2

  #kr-title
    @apply text-3xl mb-4

  #kr-chart
    @apply mr-8

@media only screen and (max-width: 1279px)
  #kr-container.lg, #parentSetter
    margin-left: 0
    .content-card
      padding-right: 0

@media only screen and (max-width: 639px)
  #updatesCard
    margin-left: 0

button.lg
  @apply ml-40

.doughnut_chart svg path
  stroke-linecap: round !important
.max50
  max-width: 50%
  width: 100%
.card
  @apply shadow-xl

.blue, .red, .orange
  @apply shadow-md

.blue
  @apply bg-blue-6 text-white
  &:hover
    @apply bg-blue-7

.orange
  @apply bg-orange-6 text-white
  &:hover
    @apply bg-orange-7

.red
  @apply bg-red-6 text-white
  &:hover
    @apply bg-red-7

.activeSelection
  @apply border-2 border-indigo-5

.disabled:hover
  @apply bg-gray-2
</style>
